import colors from '@shared/styles/colors.sass'

const LINE_HEIGHT = 22

// function getMin (arr) {
//   return arr.reduce((prev, next) => next.y < prev ? next.y : prev, Infinity)
// }
//
// function getMax (arr) {
//   return arr.reduce((prev, next) => next.y > prev ? next.y : prev, 0)
// }
//
// function getMean (arr) {
//   if (arr.length === 0) return 0
//   return Math.round(arr.reduce((prev, next) => next.y + prev, 0) / arr.length)
// }

function getDrawableLines ({ lines, topLimit, bottomLimit }) {
  lines.sort((a, b) => b.yPosition - a.yPosition)
  const sortedLines = [...lines]
  const collidingLines = []
  const drawableLines = []
  const linesWithoutLabels = []

  while (sortedLines.length > 0 || collidingLines.length > 0) {
    const line = collidingLines.pop() || sortedLines.pop()

    const previousLine = drawableLines[drawableLines.length - 1] ||
      { importance: line.importance + 1, yPosition: topLimit - 1 }

    const previousBottomPosition = previousLine.drawTextBelow
      ? previousLine.yPosition + LINE_HEIGHT
      : previousLine.yPosition

    const isMoreImportantThanPreviousLine = line.importance > previousLine.importance
    const topPadding = Math.abs(line.importance - previousLine.importance) > 1 ? LINE_HEIGHT : 0

    const blockedByPreviousWhenTextIsAbove = line.yPosition - previousBottomPosition < LINE_HEIGHT
    const blockedByPreviousWhenTextIsBelow = line.yPosition <= previousBottomPosition + topPadding

    const ownBottomPosition = blockedByPreviousWhenTextIsAbove
      ? line.yPosition + LINE_HEIGHT
      : line.yPosition
    const blockedByNextLine = collidingLines.length > 0 || ownBottomPosition > bottomLimit

    const canDrawLineWithTextAbove = !blockedByPreviousWhenTextIsAbove && !blockedByNextLine
    const canDrawLineWithTextBelow = !blockedByPreviousWhenTextIsBelow && !blockedByNextLine

    if (canDrawLineWithTextAbove) {
      line.drawTextBelow = false
      drawableLines.push(line)
    } else if (canDrawLineWithTextBelow) {
      line.drawTextBelow = true
      drawableLines.push(line)
    } else if (blockedByPreviousWhenTextIsAbove && isMoreImportantThanPreviousLine) {
      const previousLine = drawableLines.pop()
      collidingLines.push(line)
      collidingLines.push(previousLine)
    } else if (line.importance > 1) {
      line.label = ''
      linesWithoutLabels.push(line)
    }
  }

  return { drawableLines, linesWithoutLabels }
}

function drawHorizontalLine ({ ctx, line, start, width }) {
  start = start - 20
  const textAlign = line.textAlign || 'left'

  ctx.beginPath()
  ctx.moveTo(start, line.yPosition)
  ctx.lineTo(width, line.yPosition)
  ctx.stroke()
  let textY
  let textX

  if (line.drawTextBelow === false) {
    // ctx.textBaseline = 'bottom'
    textY = line.yPosition - 5
  } else {
    // ctx.textBaseline = 'top'
    textY = line.yPosition + 12
  }

  if (textAlign === 'left') {
    ctx.textAlign = 'left'
    textX = start
  } else {
    ctx.textAlign = 'right'
    textX = width
  }

  const textWidth = ctx.measureText(line.label).width + 5
  ctx.fillStyle = 'rgba(255, 255, 255, 0.8)'
  ctx.fillRect(textX, textY - 11, textWidth, 13)
  ctx.fillStyle = colors.darkGrey
  ctx.fillText(line.label, textX, textY)
}

export default {
  afterDraw: function (chart, easing) {
    // if (easing < 0.8) return

    // const datasetIdx = 0
    const scale = chart.scales['y-axis-0']

    // const minValue = getMin(chart.data.datasets[datasetIdx].data)
    // const maxValue = getMax(chart.data.datasets[datasetIdx].data)
    // const meanValue = getMean(chart.data.datasets[datasetIdx].data)

    const ticks = [20, 60, 80].map(tickValue => ({
      label: tickValue,
      yPosition: scale.getPixelForValue(tickValue),
      color: colors.lightGrey,
      importance: 0
    }))

    const lines = [
      ...ticks,
      {
        label: '100 μg/m³',
        yPosition: scale.getPixelForValue(100),
        color: colors.lightGrey,
        importance: 1
      },
      {
        label: '40 μg/m³ (Jahresgrenzwert)',
        yPosition: scale.getPixelForValue(40),
        color: colors.darkGrey,
        importance: 1
      }
      // {
      //   label: `${maxValue} (Max)`,
      //   yPosition: scale.getPixelForValue(maxValue),
      //   color: colors.darkGrey,
      //   importance: 3
      // },
      // {
      //   label: `${meanValue} (Mittelw.)`,
      //   yPosition: scale.getPixelForValue(meanValue),
      //   color: colors.grey,
      //   importance: 2
      // },
      // {
      //   label: `${minValue} (Min)`,
      //   yPosition: scale.getPixelForValue(minValue),
      //   color: colors.darkGrey,
      //   importance: 3
      // }
    ]

    const ctx = chart.ctx
    const start = chart.chartArea.left
    const top = chart.chartArea.top
    const bottom = chart.chartArea.bottom
    const width = chart.chartArea.right
    const { drawableLines, linesWithoutLabels } = getDrawableLines({ lines, topLimit: top, bottomLimit: bottom, chart })

    ctx.fillStyle = colors.darkGrey
    ctx.strokeStyle = colors.lightGrey
    ctx.lineWidth = 1
    ctx.font = `normal 12px Interstate`

    linesWithoutLabels.forEach(line => {
      if (line.color !== ctx.strokeStyle) ctx.strokeStyle = line.color
      drawHorizontalLine({ ctx, start: start, width, line })
    })

    drawableLines.forEach(line => {
      if (line.color !== ctx.strokeStyle) ctx.strokeStyle = line.color
      drawHorizontalLine({ ctx, start, width, line })
    })

    const bottomLine = {
      label: '',
      yPosition: scale.getPixelForValue(0)
    }
    ctx.strokeStyle = colors.lightGrey
    drawHorizontalLine({ ctx, start, width, line: bottomLine })
  }
}
